import React, { Component } from 'react';
import IconCircleWrapperSC from '../Icons/Wrappers/IconCircleWrapperSC';
import UpArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

class SendMessageButton extends Component {
    render() {
      return (
        <IconCircleWrapperSC color={ this.props.buttonBackgroundColor }>
            <UpArrow style={{ width: 20, height: 20, color: 'white' }}/>
        </IconCircleWrapperSC>
      );
    }
  }
  export default SendMessageButton


// WEBPACK FOOTER //
// ./src/js/components/Button/SendMessageButton.jsx